module.exports = __webpack_public_path__ + "static/media/Egg.26d7598a.png";